export default __webpack_public_path__ + "static/media/Graph_SMP-Medium.c20d37d8.svg";